import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { fetchDemandOverTime } from '../../../Service/APIService';
import Auth from '../../../shared/Auth';
import { constants } from '../../../shared/constants';
import { chartObjectCreator } from '../../../utils/helper';
import CustomHighChart from './CustomHighChart';

const DemandOverTime = ({ type, id, units }) => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState({});

  const showData = async (demands, hours) => {
    const chart = await chartObjectCreator({
      chart: {
        renderTo: 'DemandOverTimeContainer',
        type: 'line',
        height: '300px',
      },
      yAxis: {
        title: {
          text: units.powerUnit,
        },
      },
      xAxis: {
        type: 'category',
        categories: hours,
        title: {
          text: 'Hours',
        },
      },
      series: [
        {
          name: 'Demand',
          color: _.shuffle(constants.colorObj)[0],
          marker: { enabled: false, symbol: 'circle', radius: 2 },
          lineWidth: 2,
          data: demands,
        },
      ],
    });
    setData(chart);
  };

  const bindData = () => {
    setLoading(true);
    setData({});
    fetchDemandOverTime(type, id)
      .then((response) => {
        setLoading(false);
        const { statusCode, result } = response.data;
        if (statusCode === 200) {
          const demands = _.map(result, 'peakDemand');
          const hours = _.map(result, 'hour');
          showData(demands, hours);
        } else {
          showData([], []);
        }
      })
      .catch((error) => {
        showData([], []);
        console.log(error);
      });
  };

  const fetchData = async () => {
    const checkToken = await Auth();
    if (checkToken) {
      bindData(type, id);
    }
  };

  useEffect(() => {
    fetchData(type, id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, id]);

  return <CustomHighChart isLoading={isLoading} options={data} />;
};

export default DemandOverTime;
